import { checkParams, zeroUnit, soFarDate, timePeriod } from '../../utils'
import { formatTime, formatDate, formatDatetime } from '../../filter'

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this
	let isPAIC = this.isPAIC && this.isFirstVisit && !this.isCarInsurance
	if (!isPAIC) {
		return false
	}

	let arr = []

	const hasAnamnesis = !(
		injured.anamnesis && ['0', ''].includes(injured.anamnesis.hasAnamnesis)
	)

	if (hasAnamnesis) {
		let list = [{}]
		if (injured.anamnesis && injured.anamnesis.anamnesisList.length) {
			list = injured.anamnesis.anamnesisList
		}

		const isTargetInsurance =
			this.isLiabilityInsurance || this.isAccidentInsurance
		for (const item of list) {
			let anamnesisInfoArr = []
			anamnesisInfoArr.push(
				{
					label: '诊断名称',
					value: item.clinicalDiagnosis,
				},
				{
					label: '损伤部位1',
					value: item.injuredPartOne,
				},
				{
					label: '损伤分类',
					value: item.injuredSort,
				}
			)
			arr.push(anamnesisInfoArr)
		}
	}

	const obj = {
		title: '既往史信息',
		children: arr,
		show: {
			hasAnamnesis,
		},
	}

	return obj
}
